import { useLayout } from "../../core";
import { Footer } from "./Footer";
import { toAbsoluteUrl } from "../../../helpers";
import TrustPilotBanner from "../../../../modules/common/other/TrustPilotBanner";

const pressLogos = [
  {
    src: "/media/press/thetimes.png",
    alt: "The Times logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/daily-mail_white.png",
    alt: "Daily Mail logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/thesun.png",
    alt: "The Sun logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/metro.png",
    alt: "Metro logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/thei.jpg",
    alt: "The i logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/thisismoney_logo_white.png",
    alt: "This is Money logo",
    widthClass: "w-100px",
  },
  {
    src: "/media/press/radiotimes.png",
    alt: "Radio Times Money logo",
    widthClass: "w-150px",
  },
] as const;

const FooterWrapper = () => {
  const { config } = useLayout();
  if (!config.app?.footer?.display) {
    return null;
  }

  return (
    <>
      <div className="d-flex flex-column gap-20 bg-dark px-8 py-15 text-center">
        <div
          className="d-flex flex-column gap-6 mx-auto"
          style={{ width: "min(1160px, calc(100% - 32px))" }}
        >
          <h2 className="m-0 text-white fs-2 fw-bold">As featured on</h2>

          <div className="d-flex flex-wrap gap-8 gap-md-10 gap-lg-12 gap-xl-18 justify-content-center align-items-center w-100 mx-auto">
            {pressLogos.map((logo) => (
              <div
                className="d-flex flex-column position-relative justify-content-end align-self-center"
                key={logo.src}
              >
                <img
                  className={logo.widthClass}
                  src={toAbsoluteUrl(logo.src)}
                  alt={logo.alt}
                />
              </div>
            ))}
          </div>

          <div className="d-flex flex-column gap-2 justify-content-end align-self-center">
            <p className="text-gray-400 fs-6 fs-md-5 m-0" style={{ maxWidth: "850px" }}>
              We are proud to have been selected by{" "}
              <a
                href="https://www.thetimes.com/"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                The Times
              </a>
              ,{" "}
              <a
                href="https://www.dailymail.co.uk/home/index.html"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                The Daily Mail
              </a>
              ,{" "}
              <a
                href="https://www.thesun.co.uk/"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                The Sun
              </a>
              ,{" "}
              <a
                href="https://metro.co.uk/"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                Metro,
              </a>{" "}
              <a
                href="https://inews.co.uk/"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                The i,
              </a>{" "}
                            <a
                href="https://www.thisismoney.co.uk/money/index.html"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                This Is Money
              </a>{" "}
              and{" "}
              <a
                href="https://www.radiotimesmoney.com/"
                target="_blank"
                rel="noreferrer"
                className="text-secondary text-decoration-underline"
              >
                Radio Times Money
              </a>{" "}
              to provide independent financial advice on pensions and
              investments to their readers.
            </p>
          </div>
        </div>

        <div className="d-flex flex-column gap-6 align-items-center">
          <h2 className="m-0 text-white fs-2 fw-bold">
            Trusted by customers. Protected by FSCS.
          </h2>
          <div className="d-flex flex-wrap justify-content-center align-items-center">
            <div className="d-flex flex-column position-relative justify-content-end text-center align-self-center">
              <TrustPilotBanner />
            </div>
            <div className="d-flex flex-column position-relative justify-content-end align-self-center pb-7 pe-sm-20">
              <img
                className="w-150px"
                src={toAbsoluteUrl("/media/misc/fscs-protected.png")}
                alt="FSCS protected"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="app-footer container-fluid justify-content-center"
        id="kt_app_footer"
      >
        <Footer />
      </div>
    </>
  );
};

export { FooterWrapper };
